import * as React from 'react';
import { Prompt } from 'react-router';
import { reduxForm } from 'redux-form';
import { compose, withProps, withHandlers, withState } from 'recompose';
import { get } from 'lodash';
import { Card } from 'material-ui/Card';

import { breadcrumbs } from '@inqool/uas-web-core/es/utils';
import Button from '@inqool/uas-web-core/es/components/controls/Button';
import { entityDetailEnhancer } from '@components/hoc/entityDetailEnhancer';

import { MyItemsFormBasic } from '@modules/myItems/myItemsFormBasic';

import { getMyItem, putMyItem } from '@modules/myItems/_myItemsActions';
import * as T from '@modules/myItems/_myItemsTypes';
import { myItemsLabel, myItemsPath } from './myItemsGrid';
import { Loader } from '@components/loader';
import { withNotifications } from '@components/hoc/withNotifications';

export const enhance = compose<T.MyItemFormProps, T.Outter>(
  entityDetailEnhancer<T.MyItemEnhancerProps<T.MyItem>, T.MyItem>({
    getEntity: getMyItem,
    defaultEntity: {}
  }),
  breadcrumbs(({ entity }) => [
    { label: myItemsLabel, to: myItemsPath },
    { label: get(entity, 'id') ? 'Upravit záznam' : 'Nový záznam' }
  ]),
  withNotifications({ putMyItem }),
  withState<{}, boolean, string, string>('loader', 'handleLoader', false),
  withProps<{}, T.MyItemProps>(({ entity }) => ({
    initialValues: {
      ...entity
    }
  })),
  withHandlers({
    onSubmit:
      ({ putMyItemNotify, closeItem, handleLoader }) =>
      async ({ id, note }) => {
        handleLoader(true);

        const ok = await putMyItemNotify(id, note);

        handleLoader(false);

        if (ok) {
          closeItem();
        }
      }
  }),
  reduxForm({
    form: 'module-my-items'
  })
);

export const View: React.SFC<T.Outter & T.MyItemFormProps> = props => (
  <div>
    <Prompt
      when={props.dirty && !props.submitSucceeded && !props.submitting}
      message="Vaše změny nebyly uloženy, přesto odejít?"
    />
    {props.loader && <Loader />}
    <form className="layout" onSubmit={props.handleSubmit}>
      <Card>
        <MyItemsFormBasic />
        <Button type="submit" label="Uložit a zavřít" primary={true} style={{ margin: '16px 0 16px 16px' }} />
        <Button label="Zrušit" style={{ margin: '16px 0 16px 16px' }} onClick={props.closeItem} />
      </Card>
    </form>
  </div>
);

export const MyItemsForm = enhance(View);



// WEBPACK FOOTER //
// ./src/modules/myItems/myItemsForm.tsx